import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg viewBox="0 0 66 66" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M32.778 34.192L39 40.414 40.414 39l-6.222-6.222 6.364-6.364L39.142 25l-6.364 6.364L26.414 25 25 26.414l6.364 6.364L25.142 39l1.414 1.414 6.222-6.222z" /></svg>);